import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { LoginByWeixinPage } from "./login-by-weixin";

@NgModule({
  declarations: [LoginByWeixinPage],
  imports: [IonicPageModule.forChild(LoginByWeixinPage)],
})
export class LoginByWeixinPageModule {}



// WEBPACK FOOTER //
// ./src/pages/login-by-weixin/login-by-weixin.module.ts